/* ============================================
   AMPWORKS — SHOPIFY THEME JAVASCRIPT
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── SCROLL REVEAL ──────────────────────────
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(el => observer.observe(el));
  }

  // ── STICKY HEADER EFFECT ───────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 50) {
        header.style.borderBottomColor = 'rgba(255,255,255,0.1)';
        header.style.background = 'rgba(10,10,11,0.97)';
      } else {
        header.style.borderBottomColor = 'rgba(255,255,255,0.06)';
        header.style.background = 'rgba(10,10,11,0.85)';
      }
    }, { passive: true });
  }

  // ── MOBILE MENU ────────────────────────────
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav-close');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // ── PRODUCT TABS (homepage) ────────────────
  const tabs = document.querySelectorAll('.products-tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
    });
  });

  // ── ADD TO CART FEEDBACK ──────────────────
  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const btn = this.querySelector('[data-atc-btn]') || this.querySelector('.btn-add-cart');
      if (!btn) return;

      const original = btn.innerHTML;
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added!';
      btn.classList.add('added');
      btn.disabled = true;

      try {
        const formData = new FormData(this);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (response.ok) {
          await updateCartCount();
        }
      } catch (err) {
        console.error('Add to cart error:', err);
      }

      setTimeout(() => {
        btn.innerHTML = original;
        btn.classList.remove('added');
        btn.disabled = false;
      }, 2500);
    });
  });

  // ── CART COUNT UPDATE ─────────────────────
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      const cart = await res.json();
      const count = cart.item_count;
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  }
  updateCartCount();

  // ── PRODUCT PAGE TABS ─────────────────────
  const productTabBtns = document.querySelectorAll('.product-tab-btn');
  const productTabContents = document.querySelectorAll('.product-tab-content');
  productTabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      productTabBtns.forEach(b => b.classList.remove('active'));
      productTabContents.forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      const content = document.querySelector(`.product-tab-content[data-tab="${target}"]`);
      if (content) content.classList.add('active');
    });
  });

  // ── PRODUCT GALLERY THUMBNAILS ────────────
  const thumbs = document.querySelectorAll('.product-gallery-thumb');
  const mainImg = document.querySelector('.product-gallery-main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.dataset.src || thumb.querySelector('img')?.src || mainImg.src;
        mainImg.srcset = '';
      }
    });
  });

  // ── QUANTITY INPUTS ───────────────────────
  document.querySelectorAll('.quantity-wrap').forEach(wrap => {
    const input = wrap.querySelector('.qty-input');
    const plus = wrap.querySelector('.qty-btn[data-action="plus"]');
    const minus = wrap.querySelector('.qty-btn[data-action="minus"]');
    if (!input) return;
    if (plus) plus.addEventListener('click', () => { input.value = Math.min(99, parseInt(input.value || 1) + 1); });
    if (minus) minus.addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value || 1) - 1); });
  });

  // ── VARIANT SELECTION ─────────────────────
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.product-variants');
      if (group) group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      // Update hidden variant id input
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && btn.dataset.variantId) {
        variantInput.value = btn.dataset.variantId;
      }
    });
  });

  // ── SEARCH SHORTCUT (/) ───────────────────
  document.addEventListener('keydown', (e) => {
    if (e.key === '/' && e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
      const searchInput = document.querySelector('.header-search input');
      if (searchInput) {
        searchInput.focus();
        searchInput.select();
      }
    }
  });

  // ── NEWSLETTER FORM ───────────────────────
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = this.querySelector('.newsletter-input');
      const btn = this.querySelector('.newsletter-btn');
      if (!input?.value.trim()) return;
      const origText = btn.textContent;
      btn.textContent = '✓ You\'re in!';
      btn.style.background = 'var(--success)';
      btn.style.color = 'var(--black)';
      input.value = '';
      setTimeout(() => {
        btn.textContent = origText;
        btn.style.background = '';
        btn.style.color = '';
      }, 3000);
    });
  }

  // ── ANNOUNCEMENT BAR CLOSE ────────────────
  const announcementClose = document.querySelector('.announcement-close');
  if (announcementClose) {
    announcementClose.addEventListener('click', () => {
      const bar = document.querySelector('.announcement-bar');
      if (bar) bar.style.display = 'none';
      sessionStorage.setItem('announcement-closed', '1');
    });
    if (sessionStorage.getItem('announcement-closed')) {
      const bar = document.querySelector('.announcement-bar');
      if (bar) bar.style.display = 'none';
    }
  }

});
